<template>
    <div class="notificationStatus" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="readNotification" :class="{ readNotification: isRead }"/>
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  computed: {
    isRead () {
      return this.params.value ? true : false
    }
  },
  methods: {
    readNotification () {
      // // Fire event from parent.
      this.$parent.$parent.readNotification(this.params);
    },
  }
}
</script>
<style lang="scss" scpoped>
.notificationStatus {
  .feather-icon {
    color: #c1c1c1;
    &.readNotification {
      color: #229a22;
    }
  }
}

</style>
